import React from 'react';
import EtherScanIcon from 'src/icons/EtherScanIcon';

export default function HistoryTab({ history }) {

	const historyItemsWithIcons = {
		txNumber:EtherScanIcon, // this key should be update and aligned with response from api
	};

	const headers = ['Date', 'KEY ID', 'CLAIMED', 'TXN'];

	return <div className='w-full h-auto mt-12'> 

		{history.length > 0 && <div className='flex justify-between items-center'>
			{headers.map( ( header, index )=>{
				return <span key={index}
					className={`text-[#B3FE00] text-base font-semibold leading-[140%] ${index < 3 ? 'w-[20%] max-[700px]:w-[22%]  max-[500px]:w-[24%]' : 'w-[40%] max-[700px]:w-[22%]  max-[500px]:w-[24%]'} max-[700px]:w-[22%] max-[700px]:text-[14px]`}>
					{header}
				</span>;
			})}
		</div>}
		{history.length === 0 && <div className='w-full flex justify-center items-center'><p>You have no claim history.</p></div>}
		<div>
			{history?.map( ( historyItem )=>{
				return <div className='w-full flex justify-between items-center '>
					{
						Object.keys( historyItem ).map( ( key, index )=>{
							const Icon = historyItemsWithIcons[key];
							// we need to add a variable to see if we need to have a link here or not
							// could be dependent on having an icon
							
							return <div 
								className={`${index < 3 ? 'w-[20%] max-[700px]:w-[22%] max-[500px]:w-[24%]' : 'w-[40%] max-[700px]:w-[22%]  max-[500px]:w-[24%]'} relative  my-8  text-2xl font-bold uppercase text-white -f-family-burbank flex items-center max-[700px]:text-xl max-[500px]:text-[14px]`}>
								{Icon && <span className='mr-[4px]'><Icon /></span>}
								<span className='overflow-hidden text-ellipsis'>{historyItem[key]}</span>
							</div>;
						})}
				</div>;
				
			})}
		</div>
	</div>;
}
